// extracted by mini-css-extract-plugin
export default {"cards":"Objectives_cards__yeb9y"};